<template>
    <div class="Survey" v-show="show">
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <section v-show="section === 'intro'">
                    <h1 class="Survey__title Utility--center">Statistics Reporting, Stat Codes & Motorstats</h1>
                    <p class="Survey__text Survey__text--fa Utility--center">
                        <i class="fa fa-check-square-o" aria-hidden="true"></i>
                    </p>
                    <p class="Survey__text Utility--center">
                        We would like to make life a little be easier for you when accessing information on Statistics,
                        Stat Codes and Motorstats.
                    </p>
                    <p class="Survey__text Utility--center">
                        With this in mind please take a few short minutes to complete our survey.
                    </p>
                    <p class="Survey__text Utility--center">
                        The information we receive from you will greatly assist us in delivering better systems for you
                        and your staff.
                    </p>
                    <p class="Survey__text Utility--center">We appreciate your feedback.</p>
                    <p class="Survey__text Utility--center">Thank you.</p>

                    <div class="row">
                        <div class="col-xs-6 Utility--text-right">
                            <a href="#" class="Button" @click.prevent="changeSection('reports')">Continue</a>
                        </div>
                        <div class="col-xs-6">
                            <a href="#" class="Button Button--danger" @click.prevent="hideSurvey">Maybe Later</a>
                        </div>
                    </div>
                </section>

                <section v-show="section === 'reports'">
                    <h2>Reports</h2>
                    <p>In terms of the daily / monthly reports you currently receive from SIMI...</p>

                    <div class="Form__group">
                        <div class="Form__group">
                            <label class="Form__label">What reports do you currently use?</label>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.dailyRegistrationFile)"
                                       @click.prevent="toggleSelection('reports', 'dailyRegistrationFile')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'dailyRegistrationFile')"
                                    >
                                        Daily Registration File
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.dailyMakerepFile)"
                                       @click.prevent="toggleSelection('reports', 'dailyMakerepFile')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'dailyMakerepFile')"
                                    >
                                        Daily Makerep File
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.beepbeepSummaryFile)"
                                       @click.prevent="toggleSelection('reports', 'beepbeepSummaryFile')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'beepbeepSummaryFile')"
                                    >
                                        BeepBeep Summary File
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.beepbeepSummaryLH)"
                                       @click.prevent="toggleSelection('reports', 'beepbeepSummaryLH')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'beepbeepSummaryLH')"
                                    >
                                        BeepBeep Summary LH
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.beepbeepDetail)"
                                       @click.prevent="toggleSelection('reports', 'beepbeepDetail')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'beepbeepDetail')"
                                    >
                                        BeepBeep Detail
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.mtdRegistrationFile)"
                                       @click.prevent="toggleSelection('reports', 'mtdRegistrationFile')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'mtdRegistrationFile')"
                                    >
                                        MTD Registration File
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.dayFigures)"
                                       @click.prevent="toggleSelection('reports', 'dayFigures')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'dayFigures')"
                                    >
                                        10/20/30 Day Figures
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.monthlyBooks)"
                                       @click.prevent="toggleSelection('reports', 'monthlyBooks')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'monthlyBooks')"
                                    >
                                        Monthly Books
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            Do you have to do additional work on these report - if so, how can we help cut back on this work?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.additionalWork"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            What reports are essential to your systems?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.essential"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            What can we do to improve the way you receive this information?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.receive"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            What can we do to improve the way you consume this information?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.consume"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            How many individuals in your organisation use this information?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.individuals"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            What data is NOT included in these reports that you would like to have access to in the future?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.notIncluded"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            Do you currently source other data to support the information that SIMI supply – if so could you
                            elaborate?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.otherData"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            What NEW data/information may be relevant for you in the future?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.reports.newData"></textarea>
                    </div>

                    <div class="Form__group">
                        <div class="Form__group">
                            <label class="Form__label">Would it be useful for you to be able to interrogate reports based on:</label>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.timLevelData)"
                                       @click.prevent="toggleSelection('reports', 'timLevelData')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'timLevelData')"
                                    >
                                        Tim level data
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.bhp)"
                                       @click.prevent="toggleSelection('reports', 'bhp')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'bhp')"
                                    >
                                        BHP
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.payload)"
                                       @click.prevent="toggleSelection('reports', 'payload')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'payload')"
                                    >
                                        Payload
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.reports.rrp)"
                                       @click.prevent="toggleSelection('reports', 'rrp')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('reports', 'rrp')"
                                    >
                                        RRP
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="Form__group">
                        <a href="#" class="Button Button--max-width" @click.prevent="changeSection('simiCodes')">Continue</a>
                    </div>
                </section>

                <section v-show="section === 'simiCodes'">
                    <h2>SIMICodes</h2>
                    <p>In terms of how Stat Codes are currently issued from SIMI...</p>

                    <div class="Form__group">
                        <label class="Form__label">
                            What can we do to improve the way you receive this information?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.simiCodes.improve"></textarea>
                    </div>

                    <div class="Form__group">
                        <div class="Form__group">
                            <label class="Form__label">Have you any I.T. constraints to providing additional data when setting up an SIMICode?</label>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.simiCodes.trimYN)"
                                       @click.prevent="toggleSelection('simiCodes', 'trimYN')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('simiCodes', 'trimYN')"
                                    >
                                        Trim Y/N
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.simiCodes.bhp)"
                                       @click.prevent="toggleSelection('simiCodes', 'bhp')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('simiCodes', 'bhp')"
                                    >
                                        BHP
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.simiCodes.payload)"
                                       @click.prevent="toggleSelection('simiCodes', 'payload')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('simiCodes', 'payload')"
                                    >
                                        Payload
                                    </label>
                                </div>

                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.simiCodes.rrp)"
                                       @click.prevent="toggleSelection('simiCodes', 'rrp')"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="toggleSelection('simiCodes', 'rrp')"
                                    >
                                        RRP
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="Form__group">
                        <a href="#" class="Button Button--max-width" @click.prevent="changeSection('motorstats')">Continue</a>
                        <a href="#" class="Button Button--danger Button--max-width Button--vertical-margin"
                           @click.prevent="changeSection('reports')"
                        >
                            Back
                        </a>
                    </div>
                </section>

                <section v-show="section === 'motorstats'">
                    <h2>Motorstats</h2>
                    <p>In terms of the recently developed Motor Stats System that SIMI released to you in early June...</p>

                    <div class="Form__group">
                        <label class="Form__label">
                            Do you have any feedback on this newly developed system?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.motorstats.feedback"></textarea>
                    </div>

                    <div class="Form__group">
                        <label class="Form__label">
                            What is particularly useful?
                        </label>
                        <textarea class="Form__text Form__text--textarea" v-model="form.motorstats.useful"></textarea>
                    </div>

                    <div class="Form__group">
                        <div class="Form__group">
                            <label class="Form__label">Would it be useful to create your own reports online?</label>
                        </div>

                        <div class="row">
                            <div class="col-xs-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.motorstats.create)"
                                       @click.prevent="setSelection('motorstats', 'create', true)"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="setSelection('motorstats', 'create', true)"
                                    >
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(! form.motorstats.create)"
                                       @click.prevent="setSelection('motorstats', 'create', false)"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="setSelection('motorstats', 'create', false)"
                                    >
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="Form__group">
                        <div class="Form__group">
                            <label class="Form__label">Would you like to have the ability to combine Passenger Car and LCV Reports?</label>
                        </div>

                        <div class="row">
                            <div class="col-xs-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(form.motorstats.combine)"
                                       @click.prevent="setSelection('motorstats', 'combine', true)"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="setSelection('motorstats', 'combine', true)"
                                    >
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="Form__group">
                                    <a href="#"
                                       :class="checkboxClasses(! form.motorstats.combine)"
                                       @click.prevent="setSelection('motorstats', 'combine', false)"
                                    ></a>
                                    <label class="Form__label Form__label--checkbox"
                                           @click="setSelection('motorstats', 'combine', false)"
                                    >
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="Form__group">
                        <a href="#" class="Button Button--max-width" @click.prevent="complete">Complete</a>
                        <a href="#" class="Button Button--danger Button--max-width Button--vertical-margin"
                           @click.prevent="changeSection('simiCodes')"
                        >
                            Back
                        </a>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                section: 'intro',

                form: {
                    reports: {
                        dailyRegistrationFile: false,
                        dailyMakerepFile: false,
                        beepbeepSummaryFile: false,
                        beepbeepSummaryLH: false,
                        beepbeepDetail: false,
                        mtdRegistrationFile: false,
                        dayFigures: false,
                        monthlyBooks: false,
                        additionalWork: '',
                        essential: '',
                        receive: '',
                        consume: '',
                        individuals: '',
                        notIncluded: '',
                        otherData: '',
                        newData: '',
                        timLevelData: false,
                        bhp: false,
                        payload: false,
                        rrp: false,
                    },

                    simiCodes: {
                        improve: '',
                        trimYN: false,
                        bhp: false,
                        payload: false,
                        rrp: false,
                    },

                    motorstats: {
                        feedback: '',
                        useful: '',
                        create: false,
                        combine: false,
                    }
                }
            }
        },

        props: {
            shouldDisplay: {
                type: Boolean,
                required: true,
            }
        },

        mounted() {
            if (this.shouldDisplay) {
                this.show = true;
            }
        },

        methods: {
            toggleSelection(section, target) {
                this.form[section][target] = ! this.form[section][target];

                this.$forceUpdate();
            },

            setSelection(section, target, value) {
                this.form[section][target] = value;

                this.$forceUpdate();
            },

            checkboxClasses(target) {
                return {
                    'Form__checkbox': true,
                    'Form__checkbox--checked': target
                }
            },

            changeSection(section) {
                document.querySelector('.Survey').scrollTop = 0;
                this.section = section
            },

            complete() {
                this.$http.post('/survey', { data: this.form }).then(response => {
                    this.show = false;
                })
            },

            hideSurvey() {
                this.$http.delete('/survey').then(() => {
                    this.show = false;
                })
            }
        }
    }
</script>